import { SET_STATUS_DETAILS_CACHED, SET_USER_CACHED } from "actions/cached";

const initialState = {
  statusList: [],
  users: [],
};

export default function cached(state = initialState, action) {
  const { type, payload } = action;

  switch (type) {
    case SET_STATUS_DETAILS_CACHED: {
      const statusList = state.statusList.filter((it) => it.id !== payload.id);
      statusList.push(payload);
      return {
        ...state,
        statusList,
      };
    }

    case SET_USER_CACHED: {
      const users = [
        ...state.users.filter((it) => it.id !== payload.id),
        payload,
      ];
      return {
        ...state,
        users,
      };
    }

    default:
      return state;
  }
}
